import { Spin } from "antd";
import "./EmptyWarehouseLayoutState.css";

function EmptyWarehouseLayoutState({ createLayoutHandler, loadDemoLayoutHandler, isDemoLayoutImporting }) {
  return (
    <div className="empty-layout-wrapper">
      <h1 className="title">No layout configured, yet.</h1>

      <p className="description">Get started by creating your first layout or try a demo layout to see how it works.</p>

      <div className="button-group">
        <button className="btn btn-primary" onClick={createLayoutHandler}>
          <svg className="plus-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Create Layout
        </button>

        <div className="or-divider">
          <div className="divider-line"></div>
          <div className="or-text">or</div>
          <div className="divider-line"></div>
        </div>

        <button className="btn btn-secondary" onClick={loadDemoLayoutHandler}>
          {isDemoLayoutImporting ? (
            <Spin size="small" style={{ marginRight: 8 }} />
          ) : (
            <svg className="play-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polygon points="10,8 16,12 10,16"></polygon>
            </svg>
          )}
          Load Demo Layout
        </button>
      </div>
    </div>
  );
}

export default EmptyWarehouseLayoutState;
